$(document).on('turbo:load',function(){
  $('[data-toggle-second="tooltip"]').tooltip();
});